/* Custom Before/After — Embla carousel + draggable before/after compare. */
(function () {
  'use strict';

  function initCompare(compare) {
    var handle = compare.querySelector('[data-cba-handle]');
    if (!handle) return;

    function setPos(clientX) {
      var rect = compare.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      compare.style.setProperty('--cba-pos', pct + '%');
    }

    handle.addEventListener('pointerdown', function (event) {
      // Keep Embla from starting a carousel drag while the compare handle moves.
      event.stopPropagation();
      event.preventDefault();
      handle.setPointerCapture(event.pointerId);
      compare.classList.add('is-dragging');
      setPos(event.clientX);
    });

    handle.addEventListener('pointermove', function (event) {
      if (!compare.classList.contains('is-dragging')) return;
      setPos(event.clientX);
    });

    ['pointerup', 'pointercancel'].forEach(function (type) {
      handle.addEventListener(type, function () {
        compare.classList.remove('is-dragging');
      });
    });

    handle.addEventListener('touchstart', function (event) {
      event.stopPropagation();
    }, { passive: true });

    handle.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var current = parseFloat(compare.style.getPropertyValue('--cba-pos')) || 50;
      var next = event.key === 'ArrowLeft' ? current - 5 : current + 5;
      compare.style.setProperty('--cba-pos', Math.max(0, Math.min(100, next)) + '%');
    });
  }

  function initSection(root) {
    if (root.dataset.cbaInit) return;
    root.dataset.cbaInit = 'true';

    root.querySelectorAll('[data-cba-compare]').forEach(initCompare);

    var viewport = root.querySelector('[data-cba-viewport]');
    if (!viewport || typeof EmblaCarousel === 'undefined') return;

    var embla = EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
    });

    var prev = root.querySelector('[data-cba-prev]');
    var next = root.querySelector('[data-cba-next]');
    var dotsWrap = root.querySelector('[data-cba-dots]');
    var dots = [];

    if (prev) prev.addEventListener('click', function () { embla.scrollPrev(); });
    if (next) next.addEventListener('click', function () { embla.scrollNext(); });

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = embla.scrollSnapList().map(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'custom-ba__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.addEventListener('click', function () { embla.scrollTo(index); });
        dotsWrap.appendChild(dot);
        return dot;
      });
    }

    function update() {
      var selected = embla.selectedScrollSnap();
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === selected);
      });
      if (prev) prev.disabled = !embla.canScrollPrev();
      if (next) next.disabled = !embla.canScrollNext();
    }

    buildDots();
    update();
    embla.on('select', update);
    embla.on('reInit', function () {
      buildDots();
      update();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cba]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
